<section
  class="container-wrapper"
  [ngClass]="'container-wrapper-theme-' + className()"
  [class.is-ltr]="!appTranslate.isRTL()"
>
    <mat-label class="label" [class.required]="!hideRequiredMarker() && selectControl().hasValidator(Validators.required)">
      {{ label() || '' | translate }}
      @if (infoTooltip()) {
        <mat-icon class="help-icon" svgIcon="icon_info_24" [appTooltip]="infoTooltip() | translate" [position]="TooltipPosition.BELOW" />
      }
    </mat-label>
  <mat-form-field class="container" appearance="outline" [class.readonly]="readonly()" [subscriptSizing]="subscriptSizing()">
    <mat-select
      #customSelect
      disableRipple
      [panelClass]="'select-' + className()"
      [formControl]="selectControl()"
      [placeholder]="placeholder() || '' | translate"
      [dir]="appTranslate.isRTL() ? 'rtl' : 'ltr'"
      (openedChange)="onOpenChange($event)"
      (selectionChange)="selectChangesEvent.emit($event)"
    >
      @if (searchConfig()) {
        <div class="search-box">
          <mat-form-field class="search-field" subscriptSizing="dynamic" [ngClass]="'search-field-' + className()">
            <mat-icon class="search" matSuffix svgIcon="search" />
            <input matInput [placeholder]="searchConfig()?.placeholder || '' | translate" [formControl]="searchControl" />
          </mat-form-field>
        </div>
      }
      @for (option of filteredOptions(); track option.id) {
        <mat-option
          [matTooltip]="optionTruncationConfig()[className() + '_' + option.id] ? (option.name | translate) : null"
          [matTooltipPosition]="'above'"
          [class]="'option-' + className()"
          [value]="option.id"
          [id]="className() + '_' + option.id"
        >
          {{ option.name | translate }}
          @if (option.optionIcon) {
            <mat-icon [svgIcon]="option.optionIcon" (click)="emitClick($event, option)" />
          }
        </mat-option>
      }
      <mat-option disabled [class.hide]="filteredOptions().length > 0">
        {{ 'ey.common.no_options' | translate }}
      </mat-option>
      <ng-content select="[extra-feature]" />
    </mat-select>
    <mat-icon matSuffix [svgIcon]="customSelect.panelOpen ? 'arrow-up' : 'arrow-down'" />
    @let firstError = getFirstError();
    @if (firstError) {
      <mat-error class="error-active">
        {{ firstError.message | translate }}
      </mat-error>
    }@else if(hintMessage()) {
      <mat-hint class="field-hint">
        {{ hintMessage() | translate }}
      </mat-hint>
    }
  </mat-form-field>
</section>
